import { MarvColor, MarvColorPrimary, MarvColorBlue, MarvColorGreen, MarvColorOrange, MarvColorRed } from '@marv/types';
import { MissionStatus } from '@app/models';
import { MissionItem, RetailerLogo } from '@app/components';

export class PlanningItemOperation{
    id: number;
    name: string;
    typeOfMission: string;
    source: string;
}

export class PlanningItemRetailer{
    id: number;
    name: string;
    code: string;
    logo: RetailerLogo;
}

export class PlanningItemStore{
    name: string;  
    code: string;  
    administrativeArea: string;
    zipCode: string;
    city: string;
}


export class PlanningItemArea{
    id: number;
    name: string;
}

export class PlanningItemSector{
    id: number;
    name: string;
}

export class PlanningItemWorker{
    id: number;
    name: string;
    email: string;
    phone: string;
}

export class PlanningItemSalesRep{
    id: number;
    name: string;
}

export class PlanningItemPurposes {
    name: string;
    fulfilled: boolean;
}

export class PlanningItem {
    
    activityId: number; //OU storeCheckId pour lgg  
    missionId: number;
    retailer: PlanningItemRetailer;
    store: PlanningItemStore;   
    operation: PlanningItemOperation;
    customerArea: PlanningItemArea;
    customerSector: PlanningItemSector;
    worker?: PlanningItemWorker;
    salesRep?: PlanningItemSalesRep;
    day: number;
    amStartTime: string|null;
    amEndTime: string|null;
    pmStartTime: string|null;
    pmEndTime: string|null;
    duration: string;
    presenceConfirmed: boolean;
    reportingCompleted: boolean;
    reportable: boolean;
    status: MissionStatus;    
    profil: string;  
    description: string;
    planningEntryType: string;
    affected: boolean = false;
    recoCompliance: boolean = false;
    purposes: Array<PlanningItemPurposes> = [];
    showPresenceCheckInfos: boolean = true;
    nbPictures: number;
    source: 'loga'|'lgg';
    viewDisplayed: 'month'|'week';
    
    static FromMissionItem(missionItem: MissionItem, viewDisplayed: 'month'|'week'): PlanningItem{
        let planningItem = new PlanningItem();        
        let planningItemRetailer = new PlanningItemRetailer();
        if(missionItem.retailer){
            planningItemRetailer.id = missionItem.retailer.id;
            planningItemRetailer.name = missionItem.retailer.name;
            planningItemRetailer.code = missionItem.retailer.code;
            planningItemRetailer.logo = new RetailerLogo(missionItem.retailer.name);
        }
        let planningItemStore = new PlanningItemStore();
        if(missionItem.store){
            planningItemStore.name = missionItem.store.name;
            planningItemStore.code = missionItem.store.code;
            planningItemStore.city = missionItem.store.city;
            planningItemStore.administrativeArea = missionItem.store.administrativeArea;
            planningItemStore.zipCode = missionItem.store.zipCode;
        }        
        let planningItemArea = new PlanningItemArea();
        if(missionItem.customerArea){
            planningItemArea.id = missionItem.customerArea.id;
            planningItemArea.name = missionItem.customerArea.name;
        }
        let planningItemSector = new PlanningItemSector();
        if(missionItem.customerSector){
            planningItemSector.id = missionItem.customerSector.id;
            planningItemSector.name = missionItem.customerSector.name;
        }
        if(missionItem.worker){
            planningItem.worker = {
                id: missionItem.worker.id,
                name: missionItem.worker.name,
                email: missionItem.worker.email,
                phone: missionItem.worker.phone
            };
        }        
        
        let planningItemSalesRep = new PlanningItemSalesRep();
        if(missionItem.salesRep){
            planningItemSalesRep.id = missionItem.salesRep.id;
            planningItemSalesRep.name = missionItem.salesRep.name;
        }   
        planningItem.activityId = missionItem.activityId;
        planningItem.missionId = missionItem.missionId;
        planningItem.retailer = planningItemRetailer;
        planningItem.store = planningItemStore;  
        
        let planningItemOperation = new PlanningItemOperation();       
        planningItemOperation.id = missionItem.operation.id;
        planningItemOperation.name = missionItem.operation.name;
        planningItemOperation.typeOfMission = missionItem.operation.typeOfMission;
        planningItemOperation.source = missionItem.operation.source;
        planningItem.operation = planningItemOperation;
        
        let purposes: Array<PlanningItemPurposes> = [];
        missionItem.purposes.forEach(p => {
            purposes.push({
                name: p.name,
                fulfilled: p.fulfilled
            });
        });
        planningItem.purposes = purposes;
        
        planningItem.customerArea = planningItemArea;
        planningItem.customerSector = planningItemSector;
        planningItem.salesRep = planningItemSalesRep;
        planningItem.day = missionItem.day;
        planningItem.amStartTime = missionItem.amStartTime;
        planningItem.amEndTime = missionItem.amEndTime;
        planningItem.pmStartTime = missionItem.pmStartTime;
        planningItem.pmEndTime = missionItem.pmEndTime;
        planningItem.duration = missionItem.duration;
        planningItem.presenceConfirmed = missionItem.presenceConfirmed;
        planningItem.reportingCompleted = missionItem.reportingCompleted;
        planningItem.reportable = missionItem.reportable;
        planningItem.status = missionItem.status;    
        planningItem.profil = missionItem.profil;  
        planningItem.description = missionItem.description;
        planningItem.planningEntryType = missionItem.planningEntryType;
        planningItem.affected = missionItem.affected;
        planningItem.recoCompliance = missionItem.recoCompliance;
        planningItem.showPresenceCheckInfos = missionItem.showPresenceCheckInfos;
        planningItem.nbPictures = missionItem.nbPictures;
        planningItem.source = missionItem.source;
        planningItem.viewDisplayed = viewDisplayed;
        return planningItem;
    }
    
}

